// Runs in the browser only — `output: 'export'` means there's no Next.js
// server runtime, so we deliberately ship a single client config and skip
// instrumentation.ts / sentry.server.config.ts.
//
// Note: the App-Router navigation hook `captureRouterTransitionStart` lives
// in @sentry/nextjs >= 9; we pin to 8.x and skip that export. Browser
// tracing below still captures page-load + XHR/fetch spans, just without
// router-transition spans.
import * as Sentry from '@sentry/nextjs';

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (dsn) {
    Sentry.init({
        dsn,
        environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || 'production',
        release: process.env.NEXT_PUBLIC_SENTRY_RELEASE || undefined,
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Drop noisy errors from third-party scripts (extensions, captcha
        // iframes, etc.) that we can't fix from our codebase.
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
        ],
    });
}
